import React from 'react';
import toast, { resolveValue } from 'react-hot-toast';
import { Check, Info, Loader2, X, XCircle } from 'lucide-react';
import './CustomToast.css';

// Full replacement for react-hot-toast's default bubble, rendered via
// <Toaster>{(t) => <CustomToast t={t} />}</Toaster> in App.js — every
// existing toast.success(...)/toast.error(...) call site across the app
// keeps working unchanged, this just controls how it's drawn. Colors come
// from the admin theme tokens (--admin-surface/--admin-text/etc.), so it
// follows light/dark/system automatically instead of being hardcoded.
const TYPE_META = {
    success: { Icon: Check, tone: 'success' },
    error: { Icon: XCircle, tone: 'error' },
    loading: { Icon: Loader2, tone: 'info', spin: true },
    blank: { Icon: Info, tone: 'info' },
    custom: { Icon: Info, tone: 'info' },
};

const CustomToast = ({ t }) => {
    const { Icon, tone, spin } = TYPE_META[t.type] || TYPE_META.blank;

    return (
        <div
            className={`app-toast tone-${tone} ${t.visible ? 'is-visible' : 'is-hidden'}`}
            role={t.type === 'error' ? 'alert' : 'status'}
        >
            <span className="app-toast-icon">
                <Icon size={16} className={spin ? 'app-toast-spin' : ''} />
            </span>
            <div className="app-toast-message">{resolveValue(t.message, t)}</div>
            {t.type !== 'loading' && (
                <button type="button" className="app-toast-close" onClick={() => toast.dismiss(t.id)} aria-label="Dismiss">
                    <X size={14} />
                </button>
            )}
        </div>
    );
};

export default CustomToast;
